import React, { useState, useEffect, useRef } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AddNew from "../../assets/Add New.svg";

const ItemTypes = {
  GRID_ITEM: "GRID_ITEM",
};

const DraggableGridItem = ({ id, content, index, moveItem, handleDelete }) => {
  const ref = useRef(null);

  const [, drag] = useDrag({
    type: ItemTypes.GRID_ITEM,
    item: { id, index },
  });

  const [, drop] = useDrop({
    accept: ItemTypes.GRID_ITEM,
    hover: (item, monitor) => {
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (item.index !== index) {
        moveItem(item.index, index);
        item.index = index;
      }

      // Scroll smoothly if near the top or bottom of the grid container
      const scrollThreshold = 50; // px from the edge for triggering scroll
      const scrollSpeed = 5; // scroll speed

      if (hoverClientY < scrollThreshold) {
        window.scrollBy(0, -scrollSpeed);
      } else if (hoverClientY > hoverBoundingRect.height - scrollThreshold) {
        window.scrollBy(0, scrollSpeed);
      }
    },
  });

  drag(drop(ref));

  return (
    <div ref={ref} className="grid-square card-list">
      <button
        className="close-button"
        onClick={() => handleDelete(id, content.business_name)}
      >
        &times;
      </button>
      <Card
        className="image-container"
        style={{ transition: "transform 0.2s ease" }}
      >
        <Card.Img variant="top" src={content.business_profile_image} />
      </Card>
      <Card.Body style={{ padding: "16px 0px 0px 0px" }}>
        <Card.Title
          className="card-listing-text"
          data-fullname={content.business_name}
        >
          {content.business_name}
        </Card.Title>
      </Card.Body>
    </div>
  );
};

const AddNewCard = ({ handleAddNewFeature }) => {
  return (
    <div className="grid-card">
      <div
        variant="primary"
        className="add-new-btn btn-container"
        onClick={handleAddNewFeature}
      >
        Add New <img src={AddNew} className="add-icon" alt="Add New" />
      </div>
    </div>
  );
};

const FeaturedListing = (props) => {
  const {
    items,
    setItems,
    pageNumber,
    handleFeatureStatus,
    setIsReorder,
    getListing,
  } = props;
  const navigate = useNavigate();

  useEffect(() => {
    getListing();
  }, [pageNumber]);

  const moveItem = (fromIndex, toIndex) => {
    const updatedItems = [...items];
    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);
    setItems(updatedItems);
    setIsReorder(true);
  };

  const handleDelete = (id, businessName) => {
    handleFeatureStatus(false, parseInt(id), businessName, "remove");
  };

  const handleAddNewFeature = () => {
    navigate("/business-listings/published-listings");
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="card-list-container">
        <div className="col"></div>
        <div className={`${items.length === 0 ? "" : "grid-container"}`}>
          {items.map((item, index) => (
            <DraggableGridItem
              key={item.id}
              id={item.id}
              content={item.content}
              index={index}
              moveItem={moveItem}
              handleDelete={handleDelete}
            />
          ))}

          {items.length < 9 && (
            <AddNewCard handleAddNewFeature={handleAddNewFeature} />
          )}
        </div>
        <div className="col"></div>
      </div>
    </DndProvider>
  );
};

export default FeaturedListing;
